import React from "react"

const ArrowLeftIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15.0001C12.5 15.0001 7.50001 11.3176 7.5 10C7.49999 8.68245 12.5 5.00008 12.5 5.00008" stroke="#B8B8B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default ArrowLeftIcon